/**
 * Process Detail Policy
 *
 * Fetches a single batch process by ID on init and subscribes
 * to real-time updates for that process.
 */

import { Policy } from '@commandDrivenStateEngine/core/policies';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { BatchProcessesDetailState } from '../state';
import { BatchProcessesDetailCommand } from '../commands';

export const createProcessDetailPolicy = (
  backend: ClientLibraryType,
  processId: string
): Policy<BatchProcessesDetailState, BatchProcessesDetailCommand> => ({
  name: 'process-detail',

  init: ({ dispatch }) => {
    // Fetch the process by ID
    backend.queries.BatchProcessesById( processId )
      .then( process => {
        dispatch(
          { type: 'batchProcesses/detail/data/setProcess', payload: { process }},
          { source: 'api' }
        );
      })
      .catch( error => {
        console.error( 'Error fetching batch process:', error );
        dispatch(
          { type: 'batchProcesses/detail/loading/setProcessLoading', payload: { isLoading: false }},
          { source: 'api' }
        );
      });

    // Subscribe to real-time updates for this process
    const subscription = backend.subscriptions.BatchProcesses(
      {},
      ( change: any ) => {
        // Snapshot: find matching process from snapshot items
        if ( change?.type === 'snapshot' ) {
          const matchingProcess = change.data.items.find(( p: any ) => p.id === processId );
          if ( matchingProcess ) {
            dispatch(
              { type: 'batchProcesses/detail/data/setProcess', payload: { process: matchingProcess }},
              { source: 'api' }
            );
          }
          return;
        }

        if ( change?.data?.id === processId ) {
          dispatch(
            { type: 'batchProcesses/detail/data/updateProcess', payload: { process: change.data }},
            { source: 'api' }
          );
        }
      }
    );

    return () => {
      subscription.close();
    };
  }
});
